export var ZnsMessageStatus;
(function (ZnsMessageStatus) {
    ZnsMessageStatus["PENDING"] = "PENDING";
    ZnsMessageStatus["SENT"] = "SENT";
    ZnsMessageStatus["DELIVERED"] = "DELIVERED";
    ZnsMessageStatus["FAILED"] = "FAILED";
})(ZnsMessageStatus || (ZnsMessageStatus = {}));
//# sourceMappingURL=zns-message-status.enum.js.map